<template>
    <v-card class="border-on radius-small" data-testid="comments">
      <div v-if="loading" class="text-center pa-6" data-testid="comments__loading">
        <v-progress-circular indeterminate color="primary" size="32" data-testid="comments__loading-spinner" />
        <div class="mt-2" data-testid="comments__loading-text">Loading comments...</div>
      </div>
      <div v-else ref="chatContainer" class="pa-2" style="max-height: 30vh; overflow: scroll" data-testid="comments__list">
        <div v-for="(item, index) in conversationList" :key="index" class="com-align" :data-testid="`comments__item-${index}`" :data-self="item.user == $store.state.user.id">
          <!-- you -->
          <div class="d-flex align-center justify-end mt-3 mb-1" v-if="item.user == $store.state.user.id" :data-testid="`comments__item-self-header-${index}`">
            <span>{{ item.user_detail.name }}</span>
            <v-tooltip bottom v-if="(conversationList[index - 1] || {}).user !== item.user">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar class="ml-2" size="30" elevation="10" v-bind="attrs" v-on="on" color="indigo" :data-testid="`comments__avatar-self-${index}`">
                  <v-img v-if="item.user_detail.profile_url && showprofile" alt="Avatar" width="30px" height="30" :size="30" :src="item.user_detail.profile_url" :data-testid="`comments__avatar-self-img-${index}`"></v-img>
                  <span class="white--text" v-else :data-testid="`comments__avatar-self-initial-${index}`">{{ item.user_detail.name[0] }}</span>
                </v-avatar>
              </template>
              <span>{{ item.user_detail.name }}</span>
            </v-tooltip>
            <span v-else class="mr-9"></span>
        </div>
          <div class="mb-2 d-flex flex-column all-width justify-end width-50" v-if="item.user == $store.state.user.id" :data-testid="`comments__item-self-body-${index}`">
            <div class="timeFont mr-8 text-right mt-0" :data-testid="`comments__timestamp-self-${index}`">{{ $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A") }}</div>
            <v-card class="mr-8 shadow-off radius-small" color="purpleborder" :data-testid="`comments__message-self-card-${index}`">
              <v-card-text class="shadow-off pa-2" :data-testid="`comments__message-self-text-wrapper-${index}`">
                <div class="black--text" :id="'sent-chat-message-' + index" v-html="highlightTaggedNames(item.value)" :data-testid="`comments__message-self-text-${index}`"></div>
            </v-card-text>
          </v-card>
        </div>
          <!-- sender -->
          <div class="mt-2 width-50 sender-comments" v-else :data-testid="`comments__item-other-${index}`">
            <div class="d-flex align-center justify-space-between" v-if="(conversationList[index - 1] || {}).user !== item.user" :data-testid="`comments__item-other-header-${index}`">
              <div class="d-flex align-center" :data-testid="`comments__item-other-header-inner-${index}`">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar dark size="30" v-bind="attrs" v-on="on" :color="item.user_detail._id == $store.state.user.id ? 'indigo' : 'indigo'" :data-testid="`comments__avatar-other-${index}`">
                      <v-img v-if="item.user_detail.profile_url && showprofile" alt="Avatar" width="30px" height="30" :size="30" :src="item.user_detail.profile_url" :data-testid="`comments__avatar-other-img-${index}`"></v-img>
                      <span class="white--text" v-else :data-testid="`comments__avatar-other-initial-${index}`">{{ item.user_detail.name[0] }}</span>
                    </v-avatar>
                  </template>
                  <span>{{ item.user_detail.name }}</span>
                </v-tooltip>
                <span class="ml-2" :data-testid="`comments__item-other-name-${index}`">{{ item.user_detail.name }}</span>
              </div>
            </div>
            <div v-else class="ml-9" :data-testid="`comments__item-other-header-spacer-${index}`"></div>
            <div class="mb-3 d-flex flex-column all-width justify-start" :data-testid="`comments__item-other-body-${index}`">
              <div class="ml-8" :data-testid="`comments__timestamp-other-${index}`">{{ $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A") }}</div>
              <v-card class="ml-8 radius-small shadow-off" color="lightgray" :data-testid="`comments__message-other-card-${index}`">
                <v-card-text :data-testid="`comments__message-other-text-wrapper-${index}`">
                  <div :id="'receive-chat-message-' + index" v-html="highlightTaggedNames(item.value)" :data-testid="`comments__message-other-text-${index}`"></div>
                </v-card-text>
              </v-card>
            </div>
          </div>
      </div>
    </div>
        <div v-if="(conversationList || []).length === 0" class="d-flex flex-column align-center justify-center all-height" data-testid="comments__empty">
          <v-spacer></v-spacer>
          <p class="text-font-size-md grey--text">Be the first one to comment</p>
          <v-spacer></v-spacer>
        </div>
      <div class="d-flex align-center all-width pa-2" v-if="!loading" data-testid="comments__input-wrapper">
        <lb-tagtextbox
          v-model="localQueryMsg"
          label=""
          placeholder="Type your message here"
          :hidedetails="true"
          :allTagsList="tagsList"
          :disabled="sendingComment"
          data-testid="comments__input"
          class="flex-grow-1"
        />
        <v-menu v-model="showOptions" :close-on-content-click="false" offset-y :nudge-width="200" data-testid="comments__mention-menu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-3 primaryBtn" v-bind="attrs" v-on="on" @click="showOptions = !showOptions" data-testid="comments__mention-btn">
              <v-icon data-testid="comments__mention-icon">@</v-icon>
              <v-badge v-if="selectedUsers.length" :content="selectedUsers.length" color="red" overlap class="user-badge" data-testid="comments__mention-badge">
              </v-badge>
            </v-btn>
          </template>
          <v-list class="user-list-menu" data-testid="comments__mention-user-list">
            <v-text-field
              v-model="userSearch"
              placeholder="Search users..."
              dense
              outlined
              hide-details
              class="mx-2 my-2"
              data-testid="comments__mention-search"
            />
            <v-list-item v-for="user in filteredUsersList" :key="user._id" :data-testid="`comments__mention-user-${user._id}`">
              <v-checkbox
                v-model="selectedUsers"
                :label="user.name + ' (' + user.email + ')'"
                :value="user._id"
                class="ma-0 pa-0"
                :data-testid="`comments__mention-user-checkbox-${user._id}`"
              />
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn class="ml-3 primaryBtn" :loading="sendingComment || sendingTagged" @click="sendQuery(task)" data-testid="comments__send-btn"><v-icon data-testid="comments__send-icon">mdi-send</v-icon></v-btn>
    </div>
  </v-card>
</template>
<script>
import { TAGS_LIST } from '@/modules/financialclose/utils/constants';

export default {
  name: 'Comments',
  props: {
    conversationList: {
      type: Array,
      default: () => []
    },
    task: {
      type: Object,
      default: () => ({})
    },
    queryMsg: {
      type: String,
      default: ''
    },
    showprofile: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      localQueryMsg: this.queryMsg,
      sendingComment: false,
      showOptions: false,
      selectedUsers: [],
      sendingTagged: false,
      userSearch: '',
    };
  },
  watch: {
    queryMsg(val) {
      this.localQueryMsg = val;
    },
  },
  computed: {
    usersListFlat() {
      // Prefer formDataV3 users (already fetched by fetchTask), fallback to legacy getUsersList
      const formData = this.$store.getters['tasks/getFormDataV3'];
      if (formData && formData.users) {
        return formData.users;
      }
      return this.$store.getters['tasks/getUsersList'] || [];
    },
    /**
     * O(1) user lookup map from store (backed by formDataV3).
     * Use this.userMap[id] instead of usersListFlat.find(u => u._id === id).
     */
    userMap() {
      return this.$store.getters['tasks/getUserMap'] || {};
    },
    filteredUsersList() {
      if (!this.userSearch) return this.usersListFlat;
      const search = this.userSearch.toLowerCase();
      return this.usersListFlat.filter(user =>
        user.name.toLowerCase().includes(search) ||
        (user.email && user.email.toLowerCase().includes(search))
      );
    },
    metadata() {
      // Prefer metadata from task prop, fallback to store if needed
      if (this.task && this.task.metadata && this.task.metadata._id) {
        return this.task.metadata;
      } else if (this.task && this.task.project && this.task.project._id) {
        return this.task.project;
      } else if (this.$store.getters['tasks/getTaskListData'] && this.$store.getters['tasks/getTaskListData'].metadata && this.$store.getters['tasks/getTaskListData'].metadata._id) {
        return this.$store.getters['tasks/getTaskListData'].metadata;
      }
      return {};
    },
    tagsList() {
      return TAGS_LIST || [];
    },
  },
  mounted() {
    // Users are already available from formDataV3 (fetched by fetchTask/getAllTasks).
    // Only call legacy getUsersFormData if formDataV3 is not populated yet.
    const formData = this.$store.getters['tasks/getFormDataV3'];
    if (!formData || !formData.users || !formData.users.length) {
      this.$store.dispatch('tasks/getUsersFormData');
    }
  },
  methods: {
    /**
     * Highlight @ mentions and # tags in message display
     */
    highlightTaggedNames(value) {
      // Highlight both @ mentions and # tags
      let result = value.replace(/@([A-Za-z0-9_]+)/g, "<span class='tagged-name'>$1</span>");
      result = result.replace(/(#[A-Za-z0-9_]+)/g, "<span class='hash-tag'>$1</span>");
      return result;
    },
    async sendQuery(task) {
      if (!this.localQueryMsg) return;
      this.sendingComment = true;
      let msg = this.localQueryMsg;
      let coloredTaggedNames = '';
      // If tagged users, prepend their names to the comment
      if (this.selectedUsers.length) {
        const taggedNamesArr = this.selectedUsers
          .map(id => {
            const user = this.userMap[id];
            return user ? `<span class='tagged-name'>${user.name}</span>` : '';
          })
          .filter(Boolean);
        // Only tagged names colored, not the value
        coloredTaggedNames = taggedNamesArr.join(', ');
        msg = coloredTaggedNames + (coloredTaggedNames ? ' ' : '') + this.localQueryMsg;
      }
      this.localQueryMsg = "";
      let dataObject = {
        type: "string",
        value: msg,
        status: "",
      };
      if (!this.metadata._id) {
        this.sendingComment = false;
        this.$store.commit('sbError', 'No project found: metadata._id is missing');
        return;
      }
      let commentSuccess = false;
      let taggedSuccess = false;
      try {
        const result = await this.$store.dispatch('tasks/addConversation', {
          metadataId: this.metadata._id,
          taskId: task._id,
          dataObject,
          context: this
        });
        if (result && result.success) {
          commentSuccess = true;
          // Add the new comment to the conversationList immediately
          const user = this.$store.state.user.id;
          const user_detail = this.$store.state.user;
          const newComment = {
            value: dataObject.value,
            user,
            user_detail,
            created_at: new Date().toISOString()
          };
          if (Array.isArray(this.conversationList)) {
            this.conversationList.push(newComment);
          }
          this.$emit('refresh');
        }
        // Send tagged notification if users and comment are present
        if (this.selectedUsers.length && msg) {
          this.sendingTagged = true;
          const taggedUsers = this.selectedUsers.map(id => {
            const user = this.userMap[id];
            return { name: user ? user.name : id, email: user && user.email ? user.email : '' };
          });
          const taggedResult = await this.$store.dispatch('tasks/triggerTaggedNotification', {
            taggedUsers,
            msg,
            task: this.task
          });
          if (taggedResult && taggedResult.success) {
            taggedSuccess = true;
            this.selectedUsers = [];
          }
          this.sendingTagged = false;
        }
      } catch (err) {
        this.$store.commit(
          "sbError",
          err.message || err || "Unknown error!"
        );
        console.log(err);
      } finally {
        // Only reset sendingComment if both comment and tagged notification are done
        this.sendingComment = true;
        if (commentSuccess && (!this.selectedUsers.length || taggedSuccess)) {
          this.sendingComment = false;
        }
      }
    },
  },
}

</script>

<style>
.com-align{
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.width-50{
  width: 50%;
}
.sender-comments{
  margin: auto;
  margin-left: 0;
}
.user-list-menu {
  max-height: 300px; 
  overflow-y: auto; 
  min-width: 200px;
}
.user-badge{
  position: absolute;
  top: 0;
  right: 0;
}
.tagged-name {
  color: #da3b01;
  font-weight: bold;
}
.hash-tag {
  color: var(--color-pending-approval);
  font-weight: bold;
}
</style>